import { createContext, useState, useContext } from "react";
import ModalRoot from "../components/modal/ModalRoot";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState(null);
    const [modalProps, setModalProps] = useState({});
    // 🚀 Memorizziamo la chiave di tracking separatamente per non sporcare il nome del modale
    const [trackingKey, setTrackingKey] = useState(null);

    const openModal = (modalName, props = {}) => {
        setActiveModal(modalName);
        setModalProps(props);
        // Se nei props passiamo una trackingKey specifica usiamo quella, altrimenti usiamo il nome del modale
        setTrackingKey(props.trackingKey || modalName);
    };

    const closeModal = () => {
        if (trackingKey) {
            localStorage.setItem(`modalSeen_${trackingKey}`, "true");
        }
        setActiveModal(null);
        setModalProps({});
        setTrackingKey(null);
    };

    const hasSeenModal = (trackingKeyName) => {
        return localStorage.getItem(`modalSeen_${trackingKeyName}`) === "true";
    };

    return (
        <ModalContext.Provider
            value={{ activeModal, modalProps, openModal, closeModal, hasSeenModal }}
        >
            {children}
            <ModalRoot />
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
export default ModalContext;